import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./stylesheet/AdminDashboard.css"; 

// Importação dos ícones SVG
import logoSvg from "../assets/logo.svg"; 
import ticketsIcon from "../assets/tickets-icon.svg";
import eventsIcon from "../assets/events-icon.svg";
import codesIcon from "../assets/codes-icon.svg";
import reportsIcon from "../assets/reports-icon.svg";

export default function AdminDashboard() {
  const navigate = useNavigate();

  useEffect(() => {
    const admin = localStorage.getItem("admin");
    if (!admin) {
      navigate("/admin");
    }
  }, [navigate]);

  function logout() {
    localStorage.removeItem("admin");
    navigate("/admin");
  }

  const getAdminName = () => {
    try {
      const adminData = localStorage.getItem("admin");
      if (adminData) {
        const user = JSON.parse(adminData);
        return user.username || "Administrador"; 
      }
      return "Administrador";
    } catch {
      return "Administrador";
    }
  };

  return (
    <div className="dashboard-page">
      {/* HEADER PADRONIZADO COM RESPIRO LATERAL */}
      <header className="dashboard-header">
        <div className="header-logo-group">
           <img src={logoSvg} alt="Logo" className="header-svg-logo" />
        </div>
        
        <div className="header-actions">
          <span className="user-info">Olá, <strong>{getAdminName()}</strong></span>
          <button onClick={logout} className="logout-button">Sair</button>
        </div>
      </header>

      {/* CONTEÚDO CENTRALIZADO (dashboard-content garante os 5% de respiro) */}
      <main className="dashboard-content">
        <h2 className="main-menu-title">Menu Principal</h2>
        
        <div className="navigation-grid">
            <button className="nav-card" onClick={() => navigate("/admin/tickets")}>
                <div className="nav-icon-wrapper blue-bg">
                    <img src={ticketsIcon} alt="Chamados" className="nav-svg-icon" />
                </div>
                <span className="nav-label">Chamados</span>
            </button>

            <button className="nav-card" onClick={() => navigate("/admin/events")}>
                <div className="nav-icon-wrapper purple-bg">
                    <img src={eventsIcon} alt="Eventos" className="nav-svg-icon" />
                </div>
                <span className="nav-label">Eventos</span>
            </button>

            <button className="nav-card" onClick={() => navigate("/admin/codes")}>
                <div className="nav-icon-wrapper green-bg">
                    <img src={codesIcon} alt="Acessos" className="nav-svg-icon" />
                </div>
                <span className="nav-label">Códigos de Acesso</span>
            </button>

            <button className="nav-card" onClick={() => navigate("/admin/reports")}>
                <div className="nav-icon-wrapper orange-bg">
                    <img src={reportsIcon} alt="Relatórios" className="nav-svg-icon" />
                </div>
                <span className="nav-label">Relatórios</span>
            </button>
        </div>
      </main>
    </div>
  );
}